const OptionSelectionTypes = {
	select: 'select',
	alpha: 'alpha',
};

export default OptionSelectionTypes;
